import React, { useEffect, useState } from "react";
import "../styles/SavedNotes.css";
import Navbar from "../components/Navbar";
import Scale from "../assets/images/scale.webp";
import NotePreview from "./NotePreview";
import emailjs from "emailjs-com";
import { Helmet } from "react-helmet";
import HomeContactSection from "../components/HomeContactSection";

function SavedNotes() {
  const [saved, setSaved] = useState([]);
  const [previewData, setPreviewData] = useState(null);

  useEffect(() => {
    const pinned = JSON.parse(localStorage.getItem("pinnedNotes") || "[]");
    setSaved(pinned);
  }, []);

  const removeNote = (fileName) => {
    const updated = saved.filter((n) => n.fileName !== fileName);
    setSaved(updated);
    localStorage.setItem("pinnedNotes", JSON.stringify(updated));
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    time: new Date().toLocaleString(),
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(false);

    const templateParams = {
      name: formData.name,
      email: formData.email,
      message: formData.message,
      time: new Date().toLocaleString(),
    };

    emailjs
      .send(
        "service_TejCodex",
        "template_9w26kov",
        templateParams,
        "-1wDk-Z48uDBTDyvr"
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" });
        },
        () => {
          setLoading(false);
          setError(true);
        }
      );
  };
  
  useEffect(() => {
    let timer;
    if (success || error) {
      timer = setTimeout(() => {
        setSuccess(false);
        setError(false);
      }, 10000); // 10 seconds = 10000 ms
    }
    return () => clearTimeout(timer);
  }, [success, error]);
  


  return (
    <div className="saved-notes-page">
      <Helmet>
        <title>Saved Notes | TejCodex</title>
        <meta name="description" content="View and manage your pinned law notes for quick access on TejCodex." />
        <link rel="canonical" href="https://tejcodex.com/savednotes" />
      </Helmet>
      {!previewData && <Navbar />}
      <div className="Smsg-trapezium">
        <div className="Smsg-trapezium-black1"></div>
        <div className="Smsg-trapezium-white1"></div>
      </div>
      <div className="Smsg-trapezium-black2"></div>
      <div className="Smsg-trapezium-white2"></div>
      <h1 className="saved-heading">📌 Saved Notes</h1>

      <section className="saved-section">
        <h2 className="section-title">Your pinned notes are saved here</h2>

        <div className="saved-list">
          <p className="saved-msg">
            ⚖️ Access your pinned subjects here and revise efficiently with
            organized study material... 📘📚
          </p>

          {saved.length === 0 && (
            <p className="empty-msg">No notes pinned yet...</p>
          )}
          {saved.map((note, idx) => (
            <div key={idx} className="saved-card">
              <div className="left-info">
                <h3 className="subject">{note.subject}</h3>
                <p className="meta">
                  {note.course} • Sem {note.semester}
                </p>
              </div>

              <div className="right-actions">
                <button
                  className="open-btn"
                  onClick={() => setPreviewData(note)}
                >
                  Open
                </button>

                <button
                  className="remove-btn"
                  onClick={() => removeNote(note.fileName)}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Section 2 */}
      <section className="info-section">
        <h2 className="info-heading">📘 How Saved Notes Work?</h2>
        <p className="info-text">
          Access your pinned subjects here and revise efficiently with organized
          study material...
        </p>
        <ul className="pin-steps">
          <li>📘 Open any note from the Notes section.</li>
          <li>
            📌 Click the “Pin Note” button at the top of the preview page.
          </li>
          <li>
            💾 The note will be saved automatically in your browser’s cache.
          </li>
          <li>⚡ Return here anytime to quickly access your pinned notes.</li>
          <li>
            🎯 No need to search again — your important subjects stay just one
            click away!
          </li>
        </ul>
      </section>

      {/* Preview Modal */}
      {previewData && (
        <NotePreview {...previewData} onClose={() => setPreviewData(null)} />
      )}

      <HomeContactSection
        scale={Scale}
        formData={formData}
        loading={loading}
        success={success}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
      <footer className="footer-section">
        <div className="footer-top">
          <img src={Scale} alt="Scale" className="footer-logo" />
          <span className="footer-title">TejCodex</span>
          <span className="footer-rights">© 2025 All rights reserved.</span>
        </div>

        <div className="footer-links">
          <a href="/">Home</a> |<a href="/notes"> Notes</a> |
          <a href="/pyqs"> PYQs</a> | <a href="/aibe-preparation"> AIBE</a> | <a href="/about"> About Us</a> |
          <a href="/contact"> Contact Us</a>
        </div>
      </footer>
    </div>
  );
}

export default SavedNotes;
